import Zooming from '../../../node_modules/zooming/build/zooming.module.js';

export default class ProductReviewImages {
	constructor () {
		this.reviewsImgs = document.querySelectorAll('.product-reviews-media .img img');

		if (this.reviewsImgs) {
			this.enableZoom();
		}
	}

	enableZoom () {
		this.reviewsImgs.forEach((img) => {
			new Zooming({
				bgOpacity: 1,
				customSize: '50%'
			}).listen(img);
		});
	}
}
